import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import CustomTooltip from "../../../../src/utils/CustomTooltip";
import {
  CircularProgress,
  Tooltip,
  FormControl,
  Grid,
  Checkbox,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Box } from "@mui/system";
import { useLocation } from "react-router-dom";
import { SnackBarAlert } from "../../../utils/SnackBar";
import TopHeading from "../../../utils/TopHeading/TopHeading";
import styled from "@emotion/styled";
import { Stack } from "@mui/system";
import moment from "moment";
import {
  createAffiliateDetail,
  getAffiliateDetail,
  updateAffiliateDetail,
  getAllCallbackType,
  getAffiliateCampaignCost,
  updateAffiliateCampaignCost,
} from "../affiliateMaster.api";
import { useNavigate } from "react-router-dom";
import { fetchAllCountry } from "../../country/country.api";
import MultipleValueDropDown from "../../../utils/multipleValueDropDown/MultipleValueDropDown";
import AsyncDropdown from "../../../utils/asyncDropdown/AsyncDropdown";
import { copyToClipboard } from "../../../utils/copyToClipboard/copyToClipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import TaskAltSharpIcon from "@mui/icons-material/TaskAltSharp";
const CreateAffiliate = () => {
  const MyComponent = styled("button")({
    backgroundColor: "white",
    color: "black",
    padding: "16px",
    borderWidth: "1px",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
  });

  const dropDowns = {
    CALLBACKTYPE: "CALLBACKTYPE",
    REQUESTTYPE: "REQUESTTYPE",
    PAYOUTTYPE: "PAYOUTTYPE",
    IDENTIFIERTYPE: "IDENTIFIERTYPE",
  };

  const [alert, setAlert] = useState(false);
  const [isTextCopied, setIsCopied] = useState(null);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countriesSelected, setCountriesSelected] = useState([]);
  const [callbackType, setCallbackType] = useState([]);
  const [selectedCallbackType, setSelectedCallbackType] = useState([]);
  const [requestTypeSelected, setRequestTypeSelected] = useState([]);
  const [payoutTypeSelected, setpayoutTypeSelected] = useState([]);
  const [reportTypeSelected, setReportTypeSelected] = useState([]);
  const [mobileUrlCopied, setMobileUrlCopied] = useState(false);
  const [webUrlCopied, setWebUrlCopied] = useState(false);
  const [callbackUrlCopied, setCallbackUrlCopied] = useState(false);
  const adminId = useSelector((state) => state.auth.userData?.adminId);
  const requestTypes = [
    { requestTypeId: "get", requestType: "GET" },
    { requestTypeId: "post", requestType: "POST" },
  ];
  const payoutTypes = [
    { payoutTypeId: 1, payoutType: "Signup" },
    { payoutTypeId: 2, payoutType: "DOI" },
  ];
  const identifiers = [
    { identifierId: "campaignId", identifierType: "Campaign Id" },
    { identifierId: "subCampaignId", identifierType: "Sub Campaign Id" },
  ];

  // ---------- Sub ID Cost table ----------
  const [subIdCostList, setSubIdCostList] = useState([]);

  const [subIdEditRow, setSubIdEditRow] = useState(null);
  const [savingSubId, setSavingSubId] = useState(false);
  const [subIdForm, setSubIdForm] = useState({ campaignCost: "" });
  const [subIdFormError, setSubIdFormError] = useState({});
  const [subCampaignId, setSubCampaignId] = useState("");
  const [campaignCost, setCampaignCost] = useState("");

  const [affiliateData, setAffiliateData] = useState({
    id: null,
    panelId: 30,
    affiliateName: "",
    affiliateUrl: "",
    affiliateWebUrl: "",
    affiliateCallbackUrl: "",
    callbackTypeId: 0,
    payoutType: 0,
    requestType: "",
    cost: 0,
    campaignCost: "",
    subCampaignId: "",
    contactEmail: "",
    billingEmail: "",
    createdBy: adminId,
    countryIds: [],
    vpn: true,
    proxy: true,
    emailFraudScore: 70,
    ipFraudScore: 70,
  });

  const handleCloseAlert = () => {
    setAlert(false);
  };

  const [validationError, setvalidationError] = useState({
    affiliateName: "",
    countries: "",
    callbackTypeId: "",
    payoutType: "",
    requestType: "",
    ipFraudScore: "",
    emailFraudScore: "",
    contactEmail: "",
    billingEmail: "",
    vpn: "",
    proxy: "",
    identifier: "",
  });

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAffiliateData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "contactEmail" || name === "billingEmail") {
      if (value && !isValidEmail(value)) {
        setvalidationError((prev) => ({
          ...prev,
          [name]: "Please enter a valid email address",
        }));
      } else {
        setvalidationError((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    } else if (name === "ipFraudScore" || name === "emailFraudScore") {
      if (value !== "" && Number(value) === 0) {
        setvalidationError((prev) => ({
          ...prev,
          [name]: "Fraud Score should be greater than 0",
        }));
      } else {
        setvalidationError((prev) => ({ ...prev, [name]: "" }));
      }
    } else {
      setvalidationError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setAffiliateData((prev) => ({
      ...prev,
      [name]: checked,
    }));
    setvalidationError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  useEffect(() => {
    fetchAllCountry()
      .then((res) => {
        if (res?.status === 200) {
          setCountries(res.data.data);
        } else {
          // console.log(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    getAllCallbackType()
      .then((res) => {
        if (res?.status === 200) {
          setCallbackType(res.data.data);
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [adminId]);

  const type = location.pathname.split("/")[2];
  let affiliateId = parseInt(location.pathname.split("/")[3]);
  const hasFetched = useRef(null);

  useEffect(() => {
    if (
      type === "edit-affiliate" &&
      affiliateId &&
      countries.length > 0 &&
      callbackType.length > 0 &&
      hasFetched.current !== affiliateId
    ) {
      hasFetched.current = affiliateId;

      getAffiliateDetail(affiliateId)
        .then((res) => {
          if (res.status === 200) {
            const affilicatedata = res.data.data[0];
            const customAffData = {
              ...affilicatedata,
              ipFraudScore: affilicatedata?.ipFraudScore ?? 70,
              vpn: affilicatedata?.vpn ?? true,
              proxy: affilicatedata?.proxy ?? true,
              emailFraudScore: affilicatedata?.emailFraudScore ?? 70,
            };
            setSubCampaignId(affilicatedata?.subCampaignId ?? "");
            setSubIdForm({ campaignCost: affilicatedata?.subCampaignId ?? "" });
            setAffiliateData(customAffData);

            const stringarray = affilicatedata?.countries?.split(",") ?? [];
            if (stringarray.length > 0) {
              const countryArray = stringarray
                .map((x) => countries.find((i) => i.countryId === Number(x)))
                .filter(Boolean);
              setCountriesSelected(countryArray);
            } else {
              setCountriesSelected([]);
            }

            const cbItem = callbackType.find(
              (i) => i.id === affilicatedata.callbackTypeId,
            );
            if (cbItem) setSelectedCallbackType(cbItem);

            const reqItem = requestTypes.find(
              (i) => i.requestTypeId === affilicatedata.requestType,
            );
            if (reqItem) setRequestTypeSelected(reqItem);

            const payItem = payoutTypes.find(
              (i) => i.payoutTypeId === affilicatedata.payoutType,
            );
            if (payItem) setpayoutTypeSelected(payItem);

            const reportItem = identifiers.find(
              (i) => i.identifierId === affilicatedata.identifier,
            );
            if (reportItem) setReportTypeSelected(reportItem);
          }
        })
        .catch(console.log);
    }
  }, [affiliateId, countries.length, type, callbackType.length]);

  useEffect(() => {
    if (type === "edit-affiliate" && affiliateId) {
      getAffiliateCampaignCost(affiliateId)
        .then((res) => {
          if (res?.status === 200) setSubIdCostList(res.data.data);
        })
        .catch((err) => console.log(err));
    }
  }, [affiliateId, type]);

  const navigate = useNavigate();

  const handleSubmit = () => {
    // console.log("clicked", type);
    let data = { ...affiliateData };
    data.countryIds = countriesSelected.map((obj) => obj.countryId);
    data.callbackTypeId = selectedCallbackType.id;
    data.requestType = requestTypeSelected.requestTypeId;
    data.payoutType = payoutTypeSelected.payoutTypeId;
    data.identifier = reportTypeSelected.identifierId;
    data.updatedBy = adminId;
    data.createdBy = adminId;
    let duplicate = {
      affiliateName: "",
      countries: "",
      callbackTypeId: "",
      payoutType: "",
      requestType: "",
      ipFraudScore: "",
      emailFraudScore: "",
      contactEmail: "",
      billingEmail: "",
      vpn: "",
      proxy: "",
    };

    if (data.affiliateName === undefined || data.affiliateName === "") {
      duplicate["affiliateName"] = "Affiliate name is required";
    }
    if (data.callbackTypeId === undefined || data.callbackTypeId === 0) {
      duplicate["callbackTypeId"] = "Callback type is required";
    }
    if (data.requestType === undefined || data.requestType === "") {
      duplicate["requestType"] = "Request Type is required";
    }
    if (data.payoutType === undefined || data.payoutType === 0) {
      duplicate["payoutType"] = "Payout Type is required";
    }
    const costStr = String(data.cost ?? "").trim();
    const cost = Number(costStr);
    if (costStr === "") {
      duplicate["cost"] = "Cost is required";
    } else if (cost <= 0) {
      duplicate["cost"] = "Cost should be greater than 0";
    } else if (cost > 20) {
      duplicate["cost"] = "Cost should not be greater than 20";
    }
    if (countriesSelected && countriesSelected.length < 1) {
      duplicate["countries"] = "Selecte Atleast One Country";
    }
    const ipScore = Number(data.ipFraudScore);
    const emailScore = Number(data.emailFraudScore);

    if (
      data.emailFraudScore === "" ||
      data.emailFraudScore === null ||
      data.emailFraudScore === undefined
    ) {
      duplicate["emailFraudScore"] = "Fraud Score should be greater than 0";
    } else if (emailScore === 0) {
      duplicate["emailFraudScore"] = "Fraud Score should be greater than 0";
    }

    if (
      data.ipFraudScore === "" ||
      data.ipFraudScore === null ||
      data.ipFraudScore === undefined
    ) {
      duplicate["ipFraudScore"] = "Fraud Score should be greater than 0";
    } else if (ipScore === 0) {
      duplicate["ipFraudScore"] = "Fraud Score should be greater than 0";
    }

    if (data.contactEmail && !isValidEmail(data.contactEmail)) {
      duplicate["contactEmail"] = "Please enter a valid email address";
    }

    if (data.billingEmail && !isValidEmail(data.billingEmail)) {
      duplicate["billingEmail"] = "Please enter a valid email address";
    }

    if (
      !data.identifier && type !== "edit-affiliate"
    ) {
      duplicate["identifier"] = "Campaign Identifier is required";
    }

    setvalidationError(duplicate);
    const noError = Object.values(duplicate).every(
      (x) => x === null || x === "",
    );
    if (!noError) {
      return;
    }
    const subCampaignId = String(affiliateData?.subCampaignId ?? "").trim();
    const rawCost = affiliateData?.campaignCost;
    const hasCost = rawCost !== null && rawCost !== undefined && rawCost !== "";
    const campaignCost = Number(rawCost);
    if (subCampaignId || hasCost) {
      if (!hasCost || Number.isNaN(campaignCost)) {
        setAlert("Campaign cost is required");
        return;
      }

      if (!subCampaignId) {
        setAlert("Campaign ID is required");
        return;
      }

      if (campaignCost <= 0) {
        setAlert("Campaign cost should be greater than 0");
        return;
      }
      if (campaignCost > 20) {
        setAlert("Campaign cost should not be greater than 20");
        return;
      }
    }

    setLoading(true);
    if (type === "edit-affiliate") {
      updateAffiliateDetail(data.id, data)
        .then((res) => {
          if (res?.status === 200) {
            if (res?.data?.success) {
              setAlert("Affiliated Updated successfully");
                setAffiliateData((prev) => ({
                  ...prev,
                  campaignCost: "",
                  subCampaignId: "",
            }));
          } else {
            setAlert(res?.data?.message || "Failed to update affiliate. Please contact to dev team.");
            setAffiliateData((prev) => ({
                  ...prev,
                  campaignCost: "",
                  subCampaignId: "",
            }))
          }
          } else {
            setAlert("Something went wrong");
          }
          return getAffiliateCampaignCost(affiliateId).then((r) => {
            if (r?.status === 200) setSubIdCostList(r.data.data);
          });
        })
        .catch((err) => {
          setAlert("Something went wrong");
        })
        .finally(() => setLoading(false));
    } else {
      createAffiliateDetail(data)
        .then((res) => {
          // console.log("create aff resp: ", res.data)
          if (res?.status === 200) {
            navigate(`/admin/edit-affiliate/${res?.data?.data?.id}`);
            setAlert("Affiliated created successfully");
            setAffiliateData({
              id: null,
              panelId: 30,
              affiliateName: "",
              affiliateUrl: "",
              affiliateWebUrl: "",
              affiliateCallbackUrl: "",
              callbackTypeId: 0,
              payoutType: 0,
              requestType: "",
              cost: 0,
              campaignCost: "",
              subCampaignId: "",
              createdBy: adminId,
              countryIds: [],
              contactEmail: "",
              billingAddress: "",
            });
          } else {
            setAlert("Failed to create affiliate. Please contact to dev team.");
          }
        })
        .catch((err) => {
          setAlert("Something went wrong");
        })
        .finally(() => setLoading(false));
    }
  };

  const handleCancel = () => {
    navigate(`/admin/affiliate-master`);
  };

  const handleCopyClick = (type) => {
    if (type === "mobile") {
      setMobileUrlCopied(true);
    } else if (type === "web") {
      setWebUrlCopied(true);
    } else {
      setCallbackUrlCopied(true);
    }
  };

  const handleCopy = async (text, fieldName) => {
    const isCopied = await copyToClipboard(text, (message) => {
      setAlert(message);
    });
    if (isCopied) {
      setIsCopied(fieldName);

      setTimeout(() => {
        setIsCopied(null);
      }, 2000);
    }
  };

  const handleDropDownChange = (value, dropDownName) => {
    switch (dropDownName) {
      case dropDowns.CALLBACKTYPE:
        setSelectedCallbackType(value);
        setvalidationError((prev) => ({
          ...prev,
          callbackTypeId: "",
        }));
        break;
      case dropDowns.REQUESTTYPE:
        setRequestTypeSelected(value);
        setvalidationError((prev) => ({
          ...prev,
          requestType: "",
        }));
        break;
      case dropDowns.PAYOUTTYPE:
        setpayoutTypeSelected(value);
        setvalidationError((prev) => ({
          ...prev,
          payoutType: "",
        }));
        break;
      case dropDowns.IDENTIFIERTYPE:
        setReportTypeSelected(value);
        setvalidationError((prev) => ({
          ...prev,
          identifier: "",
        }));
        break;

      default:
        break;
    }
  };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Validate if the pressed key is a valid digit (0-9) or a decimal point
    if (!/^\d$/.test(keyValue) && keyValue !== ".") {
      event.preventDefault(); // Prevent the key press from being registered
    }
  };

  const openSubIdEdit = (row) => {
    setSubIdEditRow(row);
    setSubIdForm({ campaignCost: row?.cost ?? "" });
    setSubIdFormError({});
  };

  const closeSubIdEdit = () => {
    setSubIdEditRow(null);
    setSubIdFormError({});
  };

  const handleSubIdSave = () => {
    const err = {};
    if (
      subIdForm.campaignCost === "" ||
      Number.isNaN(Number(subIdForm.campaignCost))
    ) {
      err.campaignCost = "Enter a valid campaign cost";
    } else if (Number(subIdForm.campaignCost) <= 0) {
      err.campaignCost = "Campaign cost should be greater than 0";
    } else if (Number(subIdForm.campaignCost) > 20) {
      err.campaignCost = "Campaign cost should not be greater than 20";
    }
    setSubIdFormError(err);
    if (Object.keys(err).length) return;

    setSavingSubId(true);
    const payload = {
      id: subIdEditRow.id,
      isActive: 1,
      campaignCost: Number(subIdForm.campaignCost),
    };
    updateAffiliateCampaignCost(payload)
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data?.success) {
            setAlert("Campaign ID cost updated successfully");
          } else {
            setAlert(res?.data?.message || "Failed to update campaign cost");
          }
          closeSubIdEdit();
          // list ko fresh server data se refresh karo
          return getAffiliateCampaignCost(affiliateId).then((r) => {
            if (r?.status === 200) setSubIdCostList(r.data.data);
          });
        } else {
          setAlert("Something went wrong while updating campaign cost");
        }
      })
      .catch(() => setAlert("Something went wrong"))
      .finally(() => setSavingSubId(false));
  };

  const handleSubIdToggle = (row, checked) => {
    const payload = {
      isActive: checked ? 1 : 0,
      id: row.id,
    };
    updateAffiliateCampaignCost(payload)
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data?.success) {
            setAlert(
              checked
                ? "Campaign ID cost is now Active"
                : "Campaign ID cost is now Inactive",
            );
          } else {
            setAlert(res?.data?.message || "Failed to update campaign cost");
          }
          return getAffiliateCampaignCost(affiliateId).then((r) => {
            if (r?.status === 200) setSubIdCostList(r.data.data);
          });
        } else {
          setAlert("Something went wrong while updating campaign cost");
        }
      })
      .catch(() => setAlert("Something went wrong"));
  };

  return (
    <>
      <TopHeading
        link={"/admin/affiliate-master"}
        heading={"Affiliate Master Detail"}
        showButton={Boolean(false)}
      />
      <Box sx={{ mx: 4, mt: 4 }}>
        <Stack direction={"row"} alignItems={"flex-start"}>
          <Paper elevation={2} sx={{ my: 4, p: 2, mr: 2, width: "100%" }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columnSpacing={{ xs: 2, md: 15 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
              sx={{ mb: 4 }}
            >
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"affiliateName"}
                  value={affiliateData?.affiliateName}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Affiliate Name"}
                  error={Boolean(validationError.affiliateName)}
                  helperText={validationError.affiliateName}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={selectedCallbackType}
                  options={callbackType}
                  objKey={"callbackType"}
                  stylized
                  label={"CallbackType"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.CALLBACKTYPE)
                  }
                  error={Boolean(validationError?.callbackTypeId)}
                  helperText={validationError?.callbackTypeId}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={requestTypeSelected}
                  options={requestTypes}
                  objKey={"requestType"}
                  stylized
                  label={"requestType"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.REQUESTTYPE)
                  }
                  error={Boolean(validationError?.requestType)}
                  helperText={validationError?.requestType}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={12}>
                <TextField
                  fullWidth
                  multiline
                  name={"affiliateUrl"}
                  value={affiliateData?.affiliateUrl}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Mobile traffic URL"}
                  InputProps={{
                    readOnly: true,
                    className: "copy-url-field",
                    endAdornment: (
                      <Tooltip title="Copy to clipboard">
                        <IconButton
                          onClick={() =>
                            handleCopy(
                              affiliateData?.affiliateUrl,
                              "affiliateUrl",
                            )
                          }
                          style={{ pointerEvents: "auto" }}
                        >
                          {isTextCopied === "affiliateUrl" ? (
                            <TaskAltSharpIcon fontSize="medium" />
                          ) : (
                            <ContentCopyIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                    ),
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={2} sm={4} md={12}>
                <TextField
                  fullWidth
                  multiline
                  name={"affiliateWebUrl"}
                  value={affiliateData?.affiliateWebUrl}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Website traffic URL"}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <Tooltip title="Copy to clipboard">
                        <IconButton
                          onClick={() =>
                            handleCopy(
                              affiliateData?.affiliateWebUrl,
                              "affiliateWebUrl",
                            )
                          }
                          style={{ pointerEvents: "auto" }}
                        >
                          {isTextCopied === "affiliateWebUrl" ? (
                            <TaskAltSharpIcon fontSize="medium" />
                          ) : (
                            <ContentCopyIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                    ),
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={2} sm={4} md={12}>
                <TextField
                  fullWidth
                  multiline
                  name={"affiliateCallbackUrl"}
                  value={affiliateData?.affiliateCallbackUrl}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Callback URL"}
                  InputProps={{
                    endAdornment: (
                      <Tooltip title="Copy to clipboard">
                        <IconButton
                          onClick={() =>
                            handleCopy(
                              affiliateData?.affiliateCallbackUrl,
                              "affiliateCallbackUrl",
                            )
                          }
                          style={{ pointerEvents: "auto" }}
                        >
                          {isTextCopied === "affiliateCallbackUrl" ? (
                            <TaskAltSharpIcon fontSize="medium" />
                          ) : (
                            <ContentCopyIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                    ),
                  }}
                  error={Boolean(validationError.affiliateCallbackUrl)}
                  helperText={validationError.affiliateCallbackUrl}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <MultipleValueDropDown
                  value={countriesSelected}
                  options={countries}
                  objkey={"countryName"}
                  label={"Select Countries"}
                  onChange={(value) => {
                    setCountriesSelected(value);
                    if (value) {
                      setvalidationError((prev) => ({
                        ...prev,
                        countries: "",
                      }));
                    }
                  }}
                  error={Boolean(validationError.countries)}
                  helperText={validationError.countries}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"cost"}
                  type={"number"}
                  value={affiliateData?.cost}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Global Cost"}
                  error={Boolean(validationError.cost)}
                  helperText={validationError.cost}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <Box
                  sx={{
                    position: "relative",
                    border: "2px solid #f0f0f0",
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      left: "12px",
                      backgroundColor: "#fff",
                      paddingX: "4px",
                      color: "#888",
                      fontSize: "0.75rem",
                    }}
                  >
                    Campaign
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "16px",
                      flexWrap: "nowrap",
                    }}
                  >
                    <Box
                      sx={{
                        flex: "0 0 60%",
                        minWidth: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <Tooltip placement="top" title={"Campaign ID"} arrow>
                        <TextField
                          placeholder="ID"
                          variant="standard"
                          name={"subCampaignId"}
                          value={affiliateData.subCampaignId}
                          onChange={handleInputChange}
                          InputProps={{ disableUnderline: true }}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-input": {
                              fontSize: "0.875rem",
                              padding: 0,
                            },
                          }}
                        />
                      </Tooltip>
                    </Box>

                    <Divider orientation="vertical" flexItem />

                    <Box
                      sx={{
                        flex: "0 0 40%",
                        minWidth: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <Tooltip placement="top" title={"Campaign Cost"} arrow>
                        <TextField
                          variant="standard"
                          placeholder="Cost"
                          type="number"
                          value={affiliateData.campaignCost}
                          name={"campaignCost"}
                          onChange={handleInputChange}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "e" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          InputProps={{ disableUnderline: true }}
                          inputProps={{ min: 0, step: "0.01" }}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-input": {
                              fontSize: "0.875rem",
                              padding: 0,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              width: "75px",
                            },
                          }}
                        />
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={payoutTypeSelected}
                  options={payoutTypes}
                  objKey={"payoutType"}
                  stylized
                  label={"payoutType"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.PAYOUTTYPE)
                  }
                  error={Boolean(validationError?.payoutType)}
                  helperText={validationError?.payoutType}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={reportTypeSelected}
                  options={identifiers}
                  objKey={"identifierType"}
                  stylized
                  label={"Campaign Identifier"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.IDENTIFIERTYPE)
                  }
                  disabled={type === "edit-affiliate"}
                  error={Boolean(validationError?.identifier)}
                  helperText={validationError?.identifier}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"contactEmail"}
                  type={"email"}
                  value={affiliateData?.contactEmail}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Contact Email"}
                  error={Boolean(validationError.contactEmail)}
                  helperText={validationError.contactEmail}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"billingEmail"}
                  type={"text"}
                  value={affiliateData?.billingEmail}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Billing Email"}
                  error={Boolean(validationError.billingEmail)}
                  helperText={validationError.billingEmail}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"ipFraudScore"}
                  type={"number"}
                  value={Number(affiliateData?.ipFraudScore)}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"IPQS Fraud Score"}
                  error={Boolean(validationError.ipFraudScore)}
                  helperText={validationError.ipFraudScore}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"emailFraudScore"}
                  type={"number"}
                  value={Number(affiliateData?.emailFraudScore)}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Email Fraud Score"}
                  error={Boolean(validationError.emailFraudScore)}
                  helperText={validationError.emailFraudScore}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <Checkbox
                  name="vpn"
                  id="checkVpnVerify"
                  onChange={handleCheckBoxChange}
                  checked={affiliateData?.vpn}
                />
                <span>VPN</span>
                <Checkbox
                  name="proxy"
                  id="checkProxy"
                  onChange={handleCheckBoxChange}
                  checked={affiliateData?.proxy}
                />
                <span>Proxy</span>
              </Grid>
            </Grid>
            <Stack
              mt={2}
              direction={"row"}
              spacing={2}
              justifyContent="flex-end"
            >
              <MyComponent disabled={loading} onClick={handleSubmit}>
                {loading ? (
                  <CircularProgress
                    size={"21px"}
                    sx={{ margin: "0 14px", color: "black", padding: 0 }}
                  />
                ) : type === "edit-affiliate" ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </MyComponent>
              <MyComponent onClick={handleCancel}>Cancel</MyComponent>
            </Stack>

            {subIdCostList?.length > 0 ? (
              <Accordion sx={{ my: 4, p: 0.5, mr: 2, width: "100%" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-content"
                  id="panel-header"
                >
                  <Typography variant="h6">
                    Campaign ID Cost Details:
                  </Typography>
                  <Divider sx={{ mt: 2 }} />
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ mt: 3 }}>
                    <TableContainer component={Paper} variant="outlined">
                      <Table size="medium" sx={{ minWidth: 900 }}>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#3F72AF" }}>
                            <TableCell sx={{ fontWeight: 600, color: "white" }}>
                              Affilite ID
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "white" }}>
                              Name
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "white" }}>
                              Campaign ID
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 600, color: "white" }}
                              align="right"
                            >
                              Cost
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "white" }}>
                              Created At
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "white" }}>
                              Updated At
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, color: "white" }}>
                              Updated By
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 600, color: "white" }}
                              align="center"
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {subIdCostList.length === 0 && (
                            <TableRow>
                              <TableCell
                                colSpan={8}
                                align="center"
                                sx={{ py: 4 }}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  No Campaign ID cost configured yet.
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}

                          {subIdCostList.map((row) => (
                            <TableRow key={row.id} hover>
                              <TableCell>{row.affiliateId ?? "-"}</TableCell>
                              <TableCell>{row.affiliateName ?? "-"}</TableCell>
                              <TableCell>{row.subCampaignId ?? "-"}</TableCell>
                              <TableCell align="right">
                                {row.cost ?? "-"}
                              </TableCell>
                              <TableCell>
                                {row.createdAt
                                  ? moment(row.createdAt).format("DD-MM-YYYY")
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                {row.updatedAt
                                  ? moment(row.updatedAt).format("DD-MM-YYYY")
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                <CustomTooltip
                                  title={row.updatedBy || "N/A"}
                                  childrenText={row.updatedBy || "--"}
                                  copiedText
                                  maxWidth="150px"
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Stack
                                  direction="row"
                                  spacing={0.5}
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  <Tooltip title="Update Campaign ID cost">
                                    <IconButton
                                      size="small"
                                      color="primary"
                                      onClick={() => openSubIdEdit(row)}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip
                                    title={row.isActive ? "Inactive" : "Active"}
                                  >
                                    <Switch
                                      size="small"
                                      checked={Boolean(row.isActive)}
                                      onChange={(e) =>
                                        handleSubIdToggle(row, e.target.checked)
                                      }
                                    />
                                  </Tooltip>
                                </Stack>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            ) : (
              ""
            )}
            <Dialog
              open={Boolean(subIdEditRow)}
              onClose={closeSubIdEdit}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle>Update Campaign ID Cost</DialogTitle>
              <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                  <TextField
                    label="Affiliate"
                    size="small"
                    fullWidth
                    disabled
                    value={`${subIdEditRow?.affiliateName ?? ""} (${subIdEditRow?.affiliateId ?? ""})`}
                  />
                  <TextField
                    label="Cost"
                    type="number"
                    size="small"
                    fullWidth
                    value={subIdForm.campaignCost}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || Number(val) >= 0) {
                        setSubIdForm((p) => ({
                          campaignCost: val,
                        }));
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e" || e.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    error={Boolean(subIdFormError.campaignCost)}
                    helperText={subIdFormError.campaignCost}
                  />
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" onClick={closeSubIdEdit}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubIdSave}
                  disabled={savingSubId}
                >
                  {savingSubId ? "Updating..." : "Update"}
                </Button>
              </DialogActions>
            </Dialog>
          </Paper>
        </Stack>
      </Box>
      <SnackBarAlert open={alert} handleClose={handleCloseAlert} />
    </>
  );
};

export default CreateAffiliate;
